import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0ee1efa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "consumer routesServedWrapper"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "dashedBorder" }

import { RoutesServed as RoutesServedComponent } from '@components';
import {
  onMounted,
  ref,
  watch,
} from 'vue';
import { RoutesServedType } from '@components/renderTypes';
import { usePortStore, useLocationStore, useVesselStore } from '@components/stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoutesServedIndex',
  props: {
    portCode: {},
    locationCode: {},
    vesselCode: {}
  },
  setup(__props: any) {

const props = __props;

const portStore = usePortStore();
const locationStore = useLocationStore();
const vesselStore = useVesselStore();

const routesServed = ref<Array<RoutesServedType>>();

onMounted(async () => {
  if (props.portCode) {
    await portStore.requestPortsServed(props.portCode);
    routesServed.value = portStore.getPortsServed;
  }
  if (props.locationCode) {
    await locationStore.requestLocationsServed(props.locationCode);
    routesServed.value = locationStore.getLocationsServed;
  }
  if (props.vesselCode) {
    await vesselStore.requestVesselsServed(props.vesselCode);
    routesServed.value = vesselStore.getVesselsServed;
  }
});

watch(() => portStore.portsServed, (port) => {
  if (port) {
    routesServed.value = portStore.getPortsServed;
  }
});

watch(() => locationStore.locationsServed, (location) => {
  if (location) {
    routesServed.value = locationStore.getLocationsServed;
  }
});

watch(() => vesselStore.vesselsServed, (vessel) => {
  if (vessel) {
    routesServed.value = vesselStore.getVesselsServed;
  }
});

return (_ctx: any,_cache: any) => {
  return (routesServed.value && routesServed.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Routes served')), 1)
          ]),
          _createVNode(_unref(RoutesServedComponent), {
            routes: routesServed.value,
            "show-desktop-view": true,
            "expand-first-item": true
          }, null, 8, ["routes"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})